import { categories } from "@/mocks/media";

export default function MediaFooter() {
  return (
    <footer className="bg-accent-900 text-accent-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-accent-950 flex items-center justify-center text-lg">
                <i className="ri-clapperboard-fill"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">
                51<span className="text-accent-400">影院</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-accent-200/90">
              娱乐八卦，克制求真。我们聚焦演员资讯与行业观察，以核实、尊重的态度还原台前幕后的真实模样，让每一口"瓜"都有据可循。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 tracking-widest">吃瓜栏目</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-2 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.key}>
                  <a href={`#${c.key}`} className="text-sm text-accent-200/80 hover:text-accent-300 whitespace-nowrap">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 tracking-widest">快速直达</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              <li><a href="#hot" className="text-sm text-accent-200/80 hover:text-accent-300">今日吃瓜热榜</a></li>
              <li><a href="#deep" className="text-sm text-accent-200/80 hover:text-accent-300">深度专题</a></li>
              <li><a href="#faq" className="text-sm text-accent-200/80 hover:text-accent-300">常见问题</a></li>
              <li><a href="#about" className="text-sm text-accent-200/80 hover:text-accent-300">关于51影院</a></li>
              <li><a href="#contact" className="text-sm text-accent-200/80 hover:text-accent-300">我要爆料</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 tracking-widest">联系方式</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-accent-200/80">
              <li className="flex items-center gap-2.5">
                <i className="ri-mail-line text-accent-300"></i>
                <a href="mailto:hello@51yingyuan.example.com" className="hover:text-accent-300">hello@51yingyuan.example.com</a>
              </li>
              <li className="flex items-center gap-2.5">
                <i className="ri-chat-follow-up-line text-accent-300"></i>
                客服时间：工作日 09:00-18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-accent-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-accent-300/70">
          <p>© 2026 51影院 · 娱乐内容资讯平台</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-quill-pen-line"></i> 采编与商务分离，尊重隐私与人格尊严
          </p>
        </div>
      </div>
    </footer>
  );
}